<div
  class="player"
  [ngClass]="
    isPlaying
      ? 'embed-responsive embed-responsive-16by9'
      : 'overflow-hidden notPlaying'
  "
  #player
  (click)="playVideo(video.id)"
  data-testid="youtube-player"
  [ngStyle]="{
    'background-image':
      'url(' +
      'https://img.youtube.com/vi/' +
      video.id +
      '/maxresdefault.jpg' +
      ')',
  }"
>
  <div class="play-button position-absolute"></div>
</div>
